var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Vuetable", {
    attrs: { fields: _vm.fields, "api-mode": false, data: _vm.documents },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }